import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { fieldPropTypes } from 'redux-form';
import { DatePickerSimpleField } from 'components/FormFieldsSimple/DatePickerSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';
import { dateOnlyToUtcWithDefaultTime } from 'utils/format/formatDate';
import { US_MEDICAL_DATE_FORMAT } from 'const/dateTime';

export class DatePickerField extends React.PureComponent {
  static propTypes = {
    ...fieldPropTypes,
    dateFormat: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right', 'center']),
  };

  static defaultProps = {
    dateFormat: US_MEDICAL_DATE_FORMAT,
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    const isoValue = value
      ? dateOnlyToUtcWithDefaultTime(value, this.props.dateFormat)
      : value;
    input.onChange(isoValue);
    input.onBlur();
  };

  render() {
    const { input, position, disabled } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <DatePickerSimpleField
          {...this.props}
          onChange={this.handleChange}
          position={position}
          disableDatepicker={disabled}
          value={
            input.value
              ? moment(input.value).format(this.props.dateFormat)
              : null
          }
          onFocus={input.onFocus}
          onBlur={input.onBlur}
        />
      </ReduxFormElementWrapper>
    );
  }
}
